import { mapState } from 'vuex';

const unitName = {
  computed: {
    ...mapState({
      units: (state) => state.global.units,
    }),
  },
  methods: {
    unitName(unitName) {
      let computedUnitName = unitName;
      try {
        computedUnitName = this.units.find((unit) => unit.name === unitName)?.name;
      } catch (e) {
        console.error(e);
      }
      return computedUnitName;
    },
  },
};

export default unitName;
